import React from 'react';
import ExperienceBrowser from '../components/ExperienceBrowser';
import './BrowseAllPage.css';

const BrowseAllPage = () => {
  return (
    <main className="browse-page">
      <section className="browse-page-hero">
  

        <h1>Find the right experience for your team.</h1>

        <p>
          Explore outings, trainings, speakers, retreats, and volunteer
          opportunities based on your location, group size, budget, and goals.
        </p>
      </section>

      <ExperienceBrowser />
    </main>
  );
};

export default BrowseAllPage;
